<template>
  <div :class="`flex flex-wrap -ml-5 pie-value pie-values-${index}`">
    <div class="md:w-1/2 w-full pl-5">
      <h3 class="text-accent font-medium text-base">{{ heading }}</h3>

      <div class="list">
        <div
          v-for="(item, i) in itemsFormatted"
          :key="item.name + heading + i"
          class="border-t border-borderGrey py-2 my-1 flex justify-between items-center"
        >
          <div class="mr-4">{{ item.name }}</div>
          <div :class="`list-hl list-hl-${i}`">
            {{ item.formattedValue }}
          </div>
        </div>
      </div>
    </div>
    <div class="md:w-1/2 w-full pl-5 flex flex-col items-center justify-center">
      <VueApexCharts
        width="100%"
        type="donut"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  props: ['heading', 'items', 'index'],
  components: { VueApexCharts },
  data: () => ({}),
  computed: {
    chartOptions() {
      return {
        labels: this.labels,
        colors: this.colours,
        chart: {
          type: 'donut',
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          donut: {
            expandOnClick: false,
          },
        },
        states: {
          hover: {
            filter: {
              type: 'darken',
              value: 0.85,
            },
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function(value) {
              return value + '%';
            },
          },
        },
      };
    },
    colours() {
      return this.index === 0
        ? ['#23E5B0', '#8887FC', '#DFDFF1']
        : ['#23E5B0', '#DFDFF1'];
    },
    itemsFormatted() {
      Array.prototype.insert = function ( index, ...items ) {
        this.splice( index, 0, ...items );
      };

      const items = JSON.parse(JSON.stringify(this.items));
      const totalDil = items.filter(({name})=> name.toLowerCase() === 'total dilution').pop();
      if (totalDil) {
        const val = (100 - totalDil.value).toFixed(2);
        items.insert(items.length - 1, {
          formattedValue: val+"%",
          name: "Existing shareholders",
          value: val
        });
        items[items.length-1] = {
          ...totalDil,
          name: "(Total dilution)"
        }
      }
      return items;
    },
    filteredItems() {
      return this.items.filter((itm) => itm.name.toLowerCase() !== 'total dilution' && itm.name.toLowerCase() !== '(total dilution)' && itm.name !== 'Dilution totale' && itm.name.toLowerCase !== 'existing shareholders');
    },
    labels() {
      const a = this.filteredItems.map((t) => t.name);
      a.push('Existing shareholders');
      return a;
    },
    series() {
      const a = this.filteredItems.map((t) => t.value);

      if (this.index === 0) {
        a.push(100 - (this.$root.seedfastDil + this.$root.newMoneyDil));
      } else {
        a.push(100 - this.$root.lateSeedfastDil);
      }

      return a;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-hl {
  @apply px-1 text-center;
  padding-top: 0.05rem;
  padding-bottom: 0.12rem;
  flex: 0 0 auto;
}
.list-hl-0 {
  @apply bg-green text-white;
}

.pie-values-0 .list-hl-1 {
  @apply bg-accent text-white;
}
.pie-values-0 .list-hl-2 ,
.pie-values-1 .list-hl-1{
  background-color:#DFDFF1;
}

</style>
